import { withAuthenticator } from 'aws-amplify-react';
import { API } from 'aws-amplify';
import React from 'react';
import GraphiQL from "graphiql";
import "graphiql/graphiql.css";

function App() {
  let divStyle = { display: 'flex', height: '100vh'};
  return (
    <div className="App">
      <div className="graphiql" style={divStyle}>
        <GraphiQL fetcher={graphQLParams => API.graphql(graphQLParams)} />,
      </div>
    </div>
  );
}

export default withAuthenticator(
  App,
  {
    usernameAttributes: 'email',
    includeGreetings: true,
    signUpConfig: {
      hideAllDefaults: true,
      signUpFields: [
        {label: "Email", key: "email", required: true, type: "email"},
        {label: "Password", key: "password", required: true, type: "password"}
      ]
    }
  }
);

